<template>
	<div class="neibianj">
	<el-row class=" mab_20" type="flex" :gutter="20">
      <el-col :span="24">
       <el-table :data="list" size="mini" border >
      <el-table-column prop="name" align="center" label="名称"></el-table-column>
      <el-table-column label="操作" align="center"  fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="editFormVisible=true">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
      </el-col>
    </el-row>
	<el-dialog title="编辑" width="1000px" :visible="editFormVisible" @close="editFormVisible = false">
        <el-form :model="editForm"  label-position="top" size="mini" :rules="editFormRules" ref="editForm">
          <el-form-item label="" prop="content">
          	<editor-bar v-model="editForm.content" :isClear="isClear"></editor-bar>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="mini" @click.native="editFormVisible = false">取消</el-button>
          <el-button type="primary" size="mini" @click.native="editAbout('editForm')">保存</el-button>
        </div>
      </el-dialog>
  </div>
</template>
<script>
import EditorBar from '../../components/wangEnduit.vue'
export default {
	name:'',
	components:{
		EditorBar
	},
	data() {
		return {
			editForm:{
				content:'',
			},
			editFormRules:{

			},
			isClear: false,
			list: [
				{
					name:'关于我们'
				}
			],
			pages: {
				page: 1,
				count: 100,
				perpage: 10,
			},
			filterForm:{},
			editFormVisible:false,
			filterForm:{},
		};
	},
	// 初始事件
	mounted: function () {
		this.init();
	},
	methods: {
		init(){
			var this_ = this;
			var url = "aboutInfo";
			this_.$post(url, {}).then((res) => {
				this_.editForm.content = res.content;
			})
		},

		editAbout(){
			var this_ = this;
			var url = "editAbout";
			var datas={
				content:this_.editForm.content
			}
			this_.$post(url,datas).then((res) => {
				this_.$message.success('修改成功');
				this_.editFormVisible=false;
			})
		},
	}
}
</script>
<style scoped>
.mab{
	margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/system/about.vue